import ServiceConfigs from 'service/config';
import { logToCloudWatch } from './trackFacebookEvents';

const logCloudWatch = logEvents => {
  const storeId = ServiceConfigs?.getStoreId();
  const allowedStoreIds = ['3715', '3517', '4416', '4633', '177', '5196', '3749', '3799', '1829', '5244', '5401'];
  const shouldLogToCloudWatch = storeId && allowedStoreIds?.includes(storeId);

  if (shouldLogToCloudWatch) {
    logToCloudWatch(logEvents);
  }
};

export default logCloudWatch;
